import React from 'react'

const FooterMiniso = () => {
    const myDate = new Date();
    const myYear = myDate.getFullYear();
    const myMonth = myDate.getMonth()>9?myDate.getMonth()+1:"0"+(myDate.getMonth()+1);
    const myDay = myDate.getDate()>9?myDate.getDate():"0"+myDate.getDate();
    const myDateComplete = myDay + "/" + myMonth + "/" + myYear;
  return (
    <div>
        <h6 className='text-center py-2 bg-danger text-white bg-opacity-75 '>
        MINISO MEXICO {myDateComplete}
        </h6>
    </div>
  )
}

export default FooterMiniso